// extracted by mini-css-extract-plugin
export var active = "_96-a";
export var activeIndicator = "_96-9";
export var disabled = "_96-b";
export var fullWidth = "_96-2";
export var lg = "_96-7";
export var md = "_96-6";
export var redoButtonTabGroup = "_96-0";
export var sm = "_96-5";
export var tabButton = "_96-4";
export var tabButtonsContainer = "_96-1";
export var themeDestructive = "_96-d";
export var themeNormal = "_96-c";
export var themeSuccess = "_96-e";
export var xl = "_96-8";
export var xs = "_96-3";